import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  // MoreOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
// import { Button } from "antd";
import increase from "@/asset/increase.svg";
import decrease from "@/asset/decrease.svg";
import nochange from "@/asset/nochange.svg";
import { TrendingDown, TrendingFlat, TrendingUp } from "@mui/icons-material";
import { formatPercentage } from "@/utils/helper";

const MetricCard = ({
  title,
  value,
  change,
  changeType,
  showTrendtag = false,
  showMorebutton = false,
  showTrendText = true,
}) => {
  const isIncrease = changeType === "increase";
  const isDecrease = changeType === "decrease";

  return (
    <div className="h-full border border-gray-100 rounded-lg py-2 px-3 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-500 font-medium">{title}</span>
            {showTrendtag && (
              <span
                className={`text-xs border-1 border-gray-300 rounded-2xl p-1 font-light ${
                  isIncrease
                    ? "text-green-600"
                    : isDecrease
                    ? "text-red-600"
                    : "text-gray-600"
                }`}
              >
                <span>
                  {isIncrease ? (
                    <TrendingUp className="text-green-500 " size={3} />
                  ) : isDecrease ? (
                    <TrendingDown className="text-red-500 " />
                  ) : (
                    <TrendingFlat className="text-gray-400 " />
                  )}
                </span>
                <span> {isIncrease ? "+" : isDecrease ? "-" : ""}</span>
                {change}
              </span>
            )}
            {/* {showMorebutton && (
              <Button
                type="text"
                icon={<MoreOutlined />}
                size="small"
                className="text-gray-400"
              />
            )} */}
          </div>
          <div className="text-xl font-semibold text-gray-900 mb-2">
            {value}
          </div>
          <div className="flex justify-between items-center">
            {showTrendText && (
              <div className="flex items-center space-x-1">
                {isIncrease ? (
                  <ArrowUpOutlined className="text-green-500 text-xs" />
                ) : isDecrease ? (
                  <ArrowDownOutlined className="text-red-500 text-xs" />
                ) : (
                  <ArrowRightOutlined className="text-gray-400 text-xs" />
                )}
                <span
                  className={`text-xs font-medium ${
                    isIncrease
                      ? "text-green-600"
                      : isDecrease
                      ? "text-red-600"
                      : "text-gray-600"
                  }`}
                >
                  {formatPercentage(change, { decimals: 0 })}
                </span>
                {/* <span className="text-xs  text-gray-500">vs last month</span> */}
              </div>
            )}
            <div className={`${!showTrendText ? "ml-auto" : ""}`}>
              <img
                src={isIncrease ? increase : isDecrease ? decrease : nochange}
                alt="chart"
                className={`object-contain ${
                  !showTrendText ? "ml-auto w-28 h-16" : "w-16 h-16"
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MetricCard;
